import React, { useEffect, useContext, useState, useMemo } from 'react';
import ComponentProvider, { ComponentContext } from '../ComponentProvider';

export const QuantityInput = ({ selectedVariant, show }) => {

  const { bundleState } = useContext(ComponentContext);
  const [bundle, setBundle] = bundleState

  const quantity = useMemo(() => {
    if (bundle.find(i => i.id == selectedVariant?.id)) {
      return bundle.find(i => i.id == selectedVariant?.id)?.quantity
    } else {
      return 1
    }
  }, [bundle, selectedVariant]);

  const handleQuantity = (value) => {

    if (bundle.find(i => i.id == selectedVariant.id)) {
      if (parseInt(value) > 0) {
        setBundle(bundle.map(i => {
          if (i.id == selectedVariant.id) {
            return { ...i, quantity: parseInt(value) }
          }
          return i
        }))
      } else {
        const updatedBundle = bundle.filter(i => i.id != selectedVariant.id)
        setBundle(updatedBundle)
      }
    }
  }

  return (
    <div className='quantityWrapper' style={{ display: show ? 'flex' : 'none' }}>
      <button type="button" className="Button Button--minus" onClick={() => handleQuantity(quantity - 1)}>
        <svg className="icon" height="1em" viewBox="0 0 20 20" width="1em">
          <use href="#icon-minus-thin"></use>
        </svg>
      </button>
      <input type="number" name="quantity" min="0" value={quantity} />
      <button type="button" className="Button Button--plus" onClick={() => handleQuantity(quantity + 1)}>
        <svg className="icon" height="1em" viewBox="0 0 20 20" width="1em">
          <use href="#icon-plus-thin"></use>
        </svg>
      </button>
    </div>
  )
}
